import { matchRoute } from '@townsquare/router/primitives/match-route';

import { routes } from './routes';

export const isTeamsForYouSelected = (pathname: string, queryParams: Record<string, string>): boolean => {
	const matchedRoute = matchRoute(routes, pathname, queryParams);

	return Boolean(matchedRoute?.route?.name === 'teams-app-for-you');
};
